/* eslint-disable */
  import { Metrics, Colors, Fonts } from '../../Themes'
import { StyleSheet } from 'react-native'
export default StyleSheet.create({
    small: {
        height: 16,
      },
  
      medium: {
        height: 32,
      },
  })


